import { StyleSheet } from 'react-native';
import Colors from '~global/Colors';

export const IcoProfile = {
  socoPoints: require('~assets/img/profile/icon-soco-point.svg'),
  socoPointsBorder: require('~assets/img/profile/icon-soco-point-border.svg'),
  memberBasic: require('~assets/img/profile/icon-member-basic.svg'),
  memberSilver: require('~assets/img/profile/icon-member-silver.svg'),
  memberGold: require('~assets/img/profile/icon-member-gold.svg'),
  memberPlatinum: require('~assets/img/profile/icon-member-platinum.svg'),
  arrowRightLilla: require('~assets/img/profile/arrow-right.svg'),
  imgPhoneRedeem: require('~assets/img/profile/img-phone-redeem-sp.png'),
  imgPhoneSelect: require('~assets/img/profile/img-phone-select-sp.png'),
  imgShopAtLilla: require('~assets/img/profile/img-shop-at-lilla.png'),
  imgWriteToReview: require('~assets/img/profile/img-write-to-review.png'),
};

export const StyleProfile = StyleSheet.create({
  FDRowAICenter: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  FDRowJCSpaceBetween: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  FDRowAICenterJCSpaceBetween: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  textBlackS10Regular: {
    fontSize: 10,
    color: Colors.black,
    fontFamily: 'figtree-medium',
  },
  textPurpleS12Bold: {
    fontSize: 12,
    color: '#905EB2',
    fontFamily: 'figtree-bold',
  },
  PaddingHorizontal16: {
    paddingHorizontal: 16,
  },
  FlexGrow1: {
    flexGrow: 1,
  },
});

export const StorageKeySoco = '@tour_soco_points';
